import { useState, useMemo, useCallback } from "react";
import { useInfiniteQuery, QueryFunctionContext } from "react-query";
import debounce from "lodash/debounce";
import { useIvideon } from "~/entity/Ivideon";

export const useGetDealersIvideonSelectLazy = () => {
  const [search, setSearch] = useState<string>("");
  const { getIvideonDealers } = useIvideon();

  const { data, fetchNextPage, hasNextPage, isFetching, isFetchingNextPage } =
    useInfiniteQuery(
      ["dealers-lazy", search],
      async ({ pageParam = 0 }: QueryFunctionContext) => {
        const res = await getIvideonDealers(
          `dealerSearch[dealerName]=${search}&page=${pageParam}&count=25`
        );
        return res.data || res;
      },
      {
        getNextPageParam: (lastPage) =>
          lastPage.page + 1 < lastPage.totalPages
            ? lastPage.page + 1
            : undefined,
        keepPreviousData: true,
      }
    );

  const options = useMemo(() => {
    return (
      data?.pages.flatMap(
        (page) =>
          page.dealers?.map((dealer: any) => ({
            label: dealer.name,
            value: dealer.id,
          })) || []
      ) || []
    );
  }, [data]);

  const onOpenChange = useCallback((open: boolean) => {
    if (!open) {
      setSearch("");
    }
  }, []);

  const debouncedSearch = useCallback(
    debounce((val: string) => setSearch(val), 500),
    []
  );

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.currentTarget;
    if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
      if (hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    }
  };

  return {
    options,
    isFetching,
    isFetchingNextPage,
    debouncedSearch,
    handleScroll,
    onOpenChange,
  };
};
